import { fromJS } from 'immutable'
import {
  PUBLIC_HOLIDAY_LIST_REQUEST,
  PUBLIC_HOLIDAY_LIST_SUCCESS,
  PUBLIC_HOLIDAY_LIST_FAILURE,
  PUBLIC_HOLIDAY_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PUBLIC_HOLIDAY_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case PUBLIC_HOLIDAY_LIST_SUCCESS:
      return state
        .set('holidays', fromJS(action.payload.holidays))
        .set('isFetching', false)
    case PUBLIC_HOLIDAY_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case PUBLIC_HOLIDAY_LIST_RESET:
      return state
        .delete('holidays')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/public-holiday/public-holiday-list-reducer.js